import { differenceInCalendarWeeks, startOfWeek, endOfWeek, eachDayOfInterval, isSameDay } from 'date-fns';

export const useStreaks = (logs) => {
    if (!logs || logs.length === 0) {
        return { currentStreak: 0, longestStreak: 0, weeklyCount: 0, weeklyDayStatuses: Array(7).fill(false) };
    }

    const logDatesParsed = logs.map(log => log.completed_at || log);
    const sortedDates = logDatesParsed.map(d => new Date(d)).sort((a, b) => a - b);
    
    // For weeklyCount and day statuses, we still need unique days
    const uniqueDates = sortedDates.filter((date, i, self) =>
        i === self.findIndex(d => isSameDay(d, date))
    );

    // For streaks, we need unique weeks
    const uniqueWeeks = sortedDates
        .map(d => startOfWeek(d, { weekStartsOn: 1 }))
        .filter((date, i, self) => i === self.findIndex(d => isSameDay(d, date)));

    let longestStreak = 0;
    let tempCurrentStreak = 0;

    for (let i = 0; i < uniqueWeeks.length; i++) {
        if (i === 0) {
            tempCurrentStreak = 1;
        } else {
            // Check if this week is exactly 1 week after the previous week
            if (differenceInCalendarWeeks(uniqueWeeks[i], uniqueWeeks[i - 1], { weekStartsOn: 1 }) === 1) {
                tempCurrentStreak++;
            } else {
                tempCurrentStreak = 1;
            }
        }
        if (tempCurrentStreak > longestStreak) {
            longestStreak = tempCurrentStreak;
        }
    }

    let currentStreak = 0;
    if (uniqueWeeks.length > 0) {
        const today = new Date();
        const currentWeekStart = startOfWeek(today, { weekStartsOn: 1 });
        const lastLogWeek = uniqueWeeks[uniqueWeeks.length - 1];

        // Difference in weeks between current week and last logged week
        const weeksDiff = differenceInCalendarWeeks(currentWeekStart, lastLogWeek, { weekStartsOn: 1 });

        // If the last log was this week (diff is 0) or last week (diff is 1), the streak is alive
        if (weeksDiff <= 1) {
            currentStreak = 1;
            for (let i = uniqueWeeks.length - 2; i >= 0; i--) {
                if (differenceInCalendarWeeks(uniqueWeeks[i + 1], uniqueWeeks[i], { weekStartsOn: 1 }) === 1) {
                    currentStreak++;
                } else {
                    break;
                }
            }
        }
    }

    if (currentStreak > longestStreak) {
        longestStreak = currentStreak;
    }

    const today = new Date();
    const start = startOfWeek(today, { weekStartsOn: 1 }); // Monday
    const end = endOfWeek(today, { weekStartsOn: 1 });
    const weekDays = eachDayOfInterval({ start, end });

    let weeklyCount = 0;
    const weeklyDayStatuses = weekDays.map(day => {
        const isCompleted = uniqueDates.some(logDate => isSameDay(logDate, day));
        if (isCompleted) weeklyCount++;
        return isCompleted;
    });

    return { currentStreak, longestStreak, weeklyCount, weeklyDayStatuses };
};
